import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { clazz } from './Table.styles.js';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import useProps from '../../../../atom/hook/useProps.js';
import '../../../../tailwind.css.js';

var Table = forwardRef(function (_props, _ref) {
    var _a = useProps(_props, []), props = _a.props, rest = _a.rest;
    return (React.createElement("table", __assign({}, rest, { ref: _ref, className: twMerge(clsx(clazz(props), rest.className)) }), rest.children));
});

export { Table as default };
